module.exports = __webpack_public_path__ + "img/news_red_tc.f92717d9.png";